/**
 * Hands a file the console fetched to the browser's download, under `filename`.
 *
 * The bytes come from an authenticated `fetch` (a plain link would carry no bearer
 * token), so the browser never sees a response it could save on its own. An object URL
 * and a clicked anchor are how a page asks for that. The URL is revoked a little after
 * the click rather than at once — Firefox has cancelled downloads whose URL was revoked
 * in the same task — and revoked at all so a long session does not hold every export.
 */
export const REVOKE_AFTER_MS = 10_000;

export function saveFile(file: Blob, filename: string): void {
  const url = URL.createObjectURL(file);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS);
}

/**
 * The name the API gives the report's CSV (`kader-report-<from>-to-<to>.csv`). Rebuilt
 * here rather than read from `Content-Disposition`: the console and the API are separate
 * origins and the API exposes no header but `x-request-id` to a cross-origin script.
 */
export function reportCsvFilename(from: string, to: string): string {
  return `kader-report-${from}-to-${to}.csv`;
}
